import resume_Designer from "./resume_Designer";
import resume_Dev from "./resume_Dev";
import resume_UX from "./resume_UX";
import resume_UXArcitect from "./resume_UXArcitect";


const allResumes = [
  resume_Designer,
  resume_UX,
  resume_UXArcitect,
  resume_Dev
]
export default allResumes;